"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.futureRouterFlags = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const RootScene_1 = __importDefault(require("@Scenes/RootScene"));
const RootLayout_1 = __importDefault(require("@Scenes/RootLayout"));
const RootErrorBoundary_1 = __importDefault(require("@Scenes/ErrorBoundary/RootErrorBoundary"));
const InactiveScene_1 = __importDefault(require("@Scenes/InactiveScene"));
const AccessDeniedScene_1 = __importDefault(require("@Scenes/AccessDeniedScene"));
const HelpScene_1 = __importDefault(require("@Scenes/HelpScene"));
const ViewWorkPublicScene_1 = __importDefault(require("@Scenes/WorkScenes/ViewWorkPublicScene"));
const PublicSearchScene_1 = __importDefault(require("@Scenes/PublicSearchScene"));
const ForgotPasswordScene_1 = __importDefault(require("@Scenes/ForgotPasswordScene"));
const CreatePasswordScene_1 = __importDefault(require("@Scenes/UserRegistrationScenes/CreatePasswordScene"));
const UserRegistrationCompleteScene_1 = __importDefault(require("@Scenes/UserRegistrationScenes/UserRegistrationCompleteScene"));
const UserRegistrationScene_1 = __importDefault(require("@Scenes/UserRegistrationScenes/UserRegistrationScene"));
const UIComponentsScene_1 = __importDefault(require("@Scenes/UIComponentsScene"));
const RequireAuth_1 = __importDefault(require("@Components/RequireAuth"));
const ChangePasswordScene_1 = __importDefault(require("@Scenes/ProfileScene/ChangePasswordScene"));
const ProfileScene_1 = require("@Scenes/ProfileScene");
const RecordingDetailsScene_1 = __importDefault(require("@Scenes/RecordingDetailsScene"));
const rightsholder_1 = __importDefault(require("@App/routes/rightsholder"));
const LoginScene_1 = __importDefault(require("@App/kit/scenes/LoginScene"));
const member_1 = __importDefault(require("./registration/member"));
const index_v2_1 = __importDefault(require("@App/routes/registration/member/index.v2"));
const EnrollMFAScene_1 = __importDefault(require("@Scenes/EnrollMFAScene"));
const songwriter_1 = __importDefault(require("@App/routes/songwriter"));
const songwriter_2 = __importDefault(require("@App/routes/registration/songwriter"));
const newUser_1 = __importDefault(require("@App/routes/registration/newUser"));
const NotificationPreferencesScene_1 = __importDefault(require("@Scenes/NotificationPreferencesScene"));
const RequireFeatureFlag_1 = __importDefault(require("@Components/RequireFeatureFlag"));
const route_1 = require("@App/navigation/route");
exports.futureRouterFlags = {
    v7_relativeSplatPath: true,
    v7_startTransition: true,
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true,
};
const createRouter = () => {
    const registrationMemberRoutes = (0, member_1.default)();
    const registrationMemberRoutesV2 = (0, index_v2_1.default)();
    const rightsholderRoutes = (0, rightsholder_1.default)();
    const songwriterRoutes = (0, songwriter_1.default)();
    const songwriterRegistrationRoutes = (0, songwriter_2.default)();
    const newUserRoutes = (0, newUser_1.default)();
    const futureFlags = {
        future: exports.futureRouterFlags,
    };
    return (0, react_router_dom_1.createBrowserRouter)([
        {
            path: '',
            element: react_1.default.createElement(RootLayout_1.default, null),
            errorElement: react_1.default.createElement(RootErrorBoundary_1.default, null),
            children: [
                {
                    path: route_1.LOGIN_ROUTE,
                    element: react_1.default.createElement(LoginScene_1.default, null),
                },
                {
                    path: route_1.RELEASE_NOTES_ROUTE,
                    element: (react_1.default.createElement(RequireAuth_1.default, null,
                        react_1.default.createElement(RootScene_1.default, null))),
                },
                {
                    path: route_1.UPCOMING_NOTES_ROUTE,
                    element: (react_1.default.createElement(RequireAuth_1.default, null,
                        react_1.default.createElement(RootScene_1.default, null))),
                },
                {
                    path: route_1.SIGN_UP_ROUTE,
                    element: react_1.default.createElement(UserRegistrationScene_1.default, null),
                },
                {
                    path: route_1.SIGN_UP_COMPLETE_ROUTE,
                    element: react_1.default.createElement(UserRegistrationCompleteScene_1.default, null),
                },
                {
                    path: route_1.CREATE_PASSWORD_ROUTE_WITH_ACT_CODE,
                    element: react_1.default.createElement(CreatePasswordScene_1.default, null),
                },
                {
                    path: route_1.ENROLL_MFA_ROUTE,
                    element: react_1.default.createElement(EnrollMFAScene_1.default, null),
                },
                {
                    path: route_1.FORGOT_PASSWORD_ROUTE,
                    element: react_1.default.createElement(ForgotPasswordScene_1.default, null),
                },
                {
                    path: route_1.SEARCH_ROUTE_WITH_TAB_NAME,
                    element: react_1.default.createElement(PublicSearchScene_1.default, null),
                },
                {
                    path: route_1.SEARCH_ROUTE,
                    element: react_1.default.createElement(PublicSearchScene_1.default, null),
                },
                {
                    path: route_1.PUBLIC_VIEW_WORK_ROUTE_WITH_WORK_ID,
                    element: react_1.default.createElement(ViewWorkPublicScene_1.default, null),
                },
                {
                    path: route_1.CONTACT_US_ROUTE,
                    element: react_1.default.createElement(HelpScene_1.default, null),
                },
                {
                    path: route_1.ACCESS_DENIED_ROUTE,
                    element: react_1.default.createElement(AccessDeniedScene_1.default, null),
                },
                {
                    path: route_1.RECORDING_DETAILS_ROUTE_WITH_RECORDING_ID,
                    element: react_1.default.createElement(RecordingDetailsScene_1.default, null),
                },
                {
                    path: route_1.INACTIVE_ROUTE,
                    element: react_1.default.createElement(InactiveScene_1.default, null),
                },
                {
                    path: route_1.UI_ROUTE,
                    element: process.env.MLC_ENV !== 'production' ? (react_1.default.createElement(RequireAuth_1.default, null,
                        react_1.default.createElement(UIComponentsScene_1.default, null))) : (react_1.default.createElement(react_router_dom_1.Navigate, { replace: true, to: navigation_1.default.home.root() })),
                },
                {
                    path: route_1.PROFILE_ROUTE,
                    element: (react_1.default.createElement(RequireAuth_1.default, null,
                        react_1.default.createElement(ProfileScene_1.ProfileScene, null))),
                },
                {
                    path: route_1.CHANGE_PASSWORD_ROUTE,
                    element: (react_1.default.createElement(RequireAuth_1.default, null,
                        react_1.default.createElement(ChangePasswordScene_1.default, null))),
                },
                {
                    path: route_1.NOTIFICATION_PREFERENCES_ROUTE,
                    element: (react_1.default.createElement(RequireAuth_1.default, null,
                        react_1.default.createElement(RequireFeatureFlag_1.default, { flagKey: 'courier-notifications' },
                            react_1.default.createElement(NotificationPreferencesScene_1.default, null)))),
                },
                registrationMemberRoutes,
                registrationMemberRoutesV2,
                rightsholderRoutes,
                songwriterRoutes,
                songwriterRegistrationRoutes,
                newUserRoutes,
                {
                    path: '',
                    element: (react_1.default.createElement(RequireAuth_1.default, null,
                        react_1.default.createElement(RootScene_1.default, null))),
                },
                {
                    path: '*',
                    element: react_1.default.createElement(react_router_dom_1.Navigate, { replace: true, to: navigation_1.default.home.root() }),
                },
            ],
        },
    ], futureFlags);
};
exports.default = createRouter;
